// URL du Cloudflare Worker (remplace l'API PHP)
// En production : remplacez par l'URL de votre Worker Cloudflare
// Exemple : 'https://api-efis-worker.VOTRE_SUBDOMAIN.workers.dev'
const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  'https://api-efis-worker.contact-efis2025.workers.dev';

// L'admin et le public partagent le même Worker — plus besoin du sous-chemin /admin
export const API_ADMIN_URL =
  process.env.REACT_APP_API_URL || API_ORIGIN;

// Upload via le Worker (qui stocke dans R2)
export const API_UPLOAD_URL =
  process.env.REACT_APP_UPLOAD_URL || `${API_ORIGIN}/upload`;
